import React from 'react';
import { useTranslate } from '../../../components/TranslationText';
import EahsForm from '../../../components/EahsForm';
import { eformInput } from '../../../common/cssclasses';
import { toast } from 'react-toastify';

/**
 * Bank Info section — read-only display of bank details from order.
 *
 * @param {object} orderDetails - Order details containing bank info fields
 */
export default function SemenBankInfo({ orderDetails }) {
    const { translate } = useTranslate();

    if (!orderDetails) return null;

    const bankFields = [
        { key: 'bankName', label: translate('web.bankName', 'Bank Name') },
        { key: 'beneficiaryName', label: translate('web.beneficiaryName', 'Beneficiary Name') },
        { key: 'iban', label: translate('web.iban', 'IBAN') },
        { key: 'bankAccountNumber', label: translate('web.bankAccountNumber', 'Bank Account Number') },
        { key: 'bankCountry', label: translate('web.bankCountry', 'Bank Country') },
        { key: 'currency', label: translate('web.currency', 'Currency') },
    ];

    // Only show if at least one bank field has data
    const hasAnyBankData = bankFields.some(({ key }) => orderDetails[key]);
    if (!hasAnyBankData) return null;

    const handleCopy = (text, label) => {
        if (!text || text === '-') return;
        navigator.clipboard.writeText(text).then(() => {
            toast.success(`${label} ${translate('web.copiedToClipboard', 'copied to clipboard')}`);
        }).catch(err => {
            console.error('Failed to copy text: ', err);
            toast.error(translate('web.copyFailed', 'Failed to copy'));
        });
    };

    return (
        <EahsForm key="bankInfo" title={translate('web.bankDetailsTransfer', 'Bank Details for Transfer')}>
            <div className="row px-3">
                {bankFields.map(({ key, label }) => (
                    <div className={eformInput} key={key}>
                        <label className="fw-bold">{label}</label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                value={orderDetails[key] || '-'}
                                disabled
                                readOnly
                            />
                            {orderDetails[key] && orderDetails[key] !== '-' && (
                                <button
                                    className="btn btn-outline-secondary"
                                    type="button"
                                    onClick={() => handleCopy(orderDetails[key], label)}
                                    title={translate('web.copy', 'Copy')}
                                >
                                    <i className="fa fa-copy" />
                                </button>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </EahsForm>
    );
}
